import validate from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.17.4_eslint@9.27.0_rollup@4.41.1_sass@1.89.0_typescript@5.8.3_vite@6.3.5/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.17.4_eslint@9.27.0_rollup@4.41.1_sass@1.89.0_typescript@5.8.3_vite@6.3.5/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/opt/buildhome/repo/middleware/auth.ts")
}